// extracted by mini-css-extract-plugin
export var formContainer = "_cb-0";
export var message = "_cb-1";